import {createSelector} from 'reselect';


const mediaSubCommentsSelector = state => state.subComments;
const commentIdSelector = (_, props) => props.commentId;
const subCommentIdSelector = (_, props) => props.subCommentId;


export const subCommentByParentId = createSelector(
    mediaSubCommentsSelector,
    commentIdSelector,
    (subComments, key) => subComments[key] || subComments['default']
);

export const subCommentsKeysByCommentId = createSelector(
    subCommentByParentId,
    subComments => subComments.map(subComment => subComment.parentId)
);

export const subCommentByCommentId = createSelector(
    mediaSubCommentsSelector,
    subCommentIdSelector,
    (subComments, subCommentId) => Object.values(subComments).filter((subComment) => subComment._id === subCommentId)[0] || {}
);